module.exports = __webpack_public_path__ + "img/uid-login-h.26d31238.png";